module.exports = __webpack_public_path__ + "img/icon-feedback.58cbe6c6.svg";